import api from './index'
import { axios } from '@/utils/request'

/**
 * @param parameter
 * @returns {*}
 */
export function teacherLogin(parameter) {
  return axios({
    url: api.TeacherLogin,
    method: 'post',
    data: parameter
  })
}

export function teacherLogout(parameter) {
  return axios({
    url: api.TeacherLogout,
    method: 'post',
    data: parameter
  })
}

export function teacherGetInfo() {
  return axios({
    url: api.TeacherGetInfo,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
